export const OPTIONSRESOLUTIONS = 'BuildAndQuote/OptionsResolutions';
export const VEHICLEVIDEO = 'BuildAndQuote/VehicleVideo';
